<script>
import { mapActions, mapGetters } from 'vuex';
import { TAB_NAME } from '@/constants/tabNameConstants';
import SmsNotification from '@/classes/SmsNotification';
import store from '@/store';

export default {
  name: 'SmsDesktopNotification',

  data() {
    return {
      notificationSoundAudioBuffer: { context: null, sourceNode: null }
    };
  },

  render() {
    return this.$scopedSlots.default({});
  },

  computed: {
    ...mapGetters('notifications', ['getLastNotification']),
    ...mapGetters('preferences', ['hasNotificationsEnable', 'selectedIncomingNotificationSound', 'getSettings']),
    ...mapGetters('conversationsV2', ['getUnreadConversations', 'activeConversation']),

    getNotifications() {
      const notifications = [];
      this.getUnreadConversations.forEach(conversation => {
        notifications.push(new SmsNotification(conversation));
      });
      return notifications;
    }
  },

  watch: {
    getUnreadConversations: function(newValue) {
      if (newValue.length > 0) {
        this.openNotification();
      }
    }
  },

  methods: {
    ...mapActions('preferences', ['updateSettings']),
    ...mapActions('conversationsV2', ['setActiveConversationId']),
    ...mapActions('notifications', ['changeLastNotification']),

    openNotification() {
      const currentUser = store.getters['user/currentUser'];
      this.getNotifications.forEach(newNotification => {
        if (this.getLastNotification.lastMessageTime !== newNotification.lastMessageTime
          && newNotification.number !== currentUser.number) {
          const notification = new Notification(newNotification.displayName, {
            body: newNotification.text,
            icon: require('@/assets/images/sms-icon.png')
          });

          notification.onclick = event => {
            event.preventDefault();
            this.goToMessage(newNotification);
            notification.close();
          };

          setTimeout(() => {
            notification.close();
          }, 10000);

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
              notification.close();
            }
          });

          this.$notificationSoundManager.playNotificationSound(
            this.selectedIncomingNotificationSound,
            this.notificationSoundAudioBuffer
          );

          this.changeLastNotification(newNotification);
        }
      });
    },
    goToMessage(newNotification) {
      window.parent.parent.focus();
      this.setActiveConversationId(newNotification.conversationId);
      const settingObject = this.getSettings;
      settingObject.interfaceState.currentTab = TAB_NAME.messages;
      this.updateSettings(settingObject);
    }
  }
};
</script>
